import Services from './services'
export default {
  name: 'taxes',
  mixins: [Services],
  data: () => ({
    tax_edit_index: -1,
    tax: {
      name: null,
      tax: null,
      type: null,
      variant: '',
      services: [],
    },
    taxes: [],
  }),
  computed: {
    taxes_types() {return this.$store.state.taxes_types},
    taxes_options() {return this.$store.state.taxes_options},
  },
  methods: {
    async update_tax() {
      const taxes = this.$communicator.then(this, await this.$communicator('taxes'))
      if (taxes) this.taxes = taxes
    },
    async tax_remove(items) {
      var indices = []
      for (const index in items) {
        indices.push(items[index]._id)
      }
      await this.$communicator('delete_taxes', {
        params: {
          indexes: indices
        }
      })
      this.$toast.success("Success", {timeout: 2000});
      this.update_tax()
    },
    async tax_save() {
      if (this.tax_edit_index == -1) {
        const save = await this.$communicator('create_tax', {
          params: this.tax
        })
        if (save.data.statusCode != 411) {
          this.$toast.success("Success", {timeout: 2000});
        }
        else {
          this.$toast.error(`${save.data.message}`, {timeout: 2000});
        }
      }
      else {
        const update = await this.$communicator('update_tax', {
          arguments: [this.tax_edit_index],
          params: this.tax
        })
        if (update.data.statusCode != 411) {
          this.$toast.success("Success", {timeout: 2000});
        }
        else {
          this.$toast.error(`${update.data.message}`, {timeout: 2000});
        }
      }
      this.update_tax()
    },
    async typing_tax(item) {
      if (item == null) {
        this.tax_edit_index = -1
        this.tax = {
          name: null,
          tax: null,
          type: null,
          variant: '',
          services: [],
        }
        this.tax.services = []
        for (const index in this.services) {
          this.tax.services.push({
            service: this.services[index]._id,
            available: false,
            service_name: this.services[index].name
          })
        }
      }
      else {
        // var tax  = this.$copy(item)
        this.tax_edit_index = item['_id']
        const tax = this.$communicator.then(this, await this.$communicator('get_taxes_by_id', {arguments: [this.tax_edit_index]}))
        if (tax) {
          this.tax = tax
          delete tax['_id']
        }
      }
    }
  },
  mounted() {
    this.taxes_type = this.taxes_types[0]
    this.taxes_option = this.taxes_options[0]
    this.update_tax()
  },
  watch: {
    services: {
      deep: true, handler() {
        this.tax.services = []
        for (const index in this.services) {
          this.tax.services.push({
            service: this.services[index]._id,
            available: false,
            service_name: this.services[index].name
          })
        }
      }
    }
  }
}
